<template>
  <svg
    id="Timeline_round_icon"
    data-name="Timeline round icon"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    :class="color"
  >
    <circle
      id="Ellipse_318"
      data-name="Ellipse 318"
      cx="12"
      cy="12"
      r="12"
      fill="#b4b6c2"
    />
    <g id="Basket_icon" data-name="Basket icon" transform="translate(5 5.5)">
      <rect
        id="Rectangle_1608"
        data-name="Rectangle 1608"
        width="14"
        height="14"
        transform="translate(0 0)"
        fill="none"
      />
      <path
        id="Union_13"
        data-name="Union 13"
        d="M-2123,6566v-3h-4a1,1,0,0,1-1-1,1,1,0,0,1,1-1h1.452l-1.7-8h10.5l-1.7,8H-2117a1,1,0,0,1,1,1,1,1,0,0,1-1,1h-4v3a1,1,0,0,1-1,1A1,1,0,0,1-2123,6566Zm2.5-5,1.277-6h-5.561l1.276,6Z"
        transform="translate(2129 -6553)"
        fill="#fff"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'RoundIcon',
  props: {
    color: {
      type: String,
    },
  },
}
</script>

<style lang="scss" scoped>
.midnight {
  circle {
    fill: $midnight;
  }
}
.blizzard {
  circle {
    fill: $blizzard;
  }
}
.grass {
  circle {
    fill: $grass;
  }
}
</style>
